import gql from 'graphql-tag';

export default gql`
  mutation CreateOneTimePassword($userId: UUID!) {
    createOneTimePassword(userId: $userId) {
      success
    }
  }
`;
